import React from "react";
import { RecIcon } from "../materials/MaterialRecordParts";
import "../materials/materialRecord.css";

/**
 * Primary "create a record" action for a workspace hub.
 * Same control Projects uses: compact, outlined gold, plus icon.
 */
export function HubPrimaryAction({ onClick, label, ariaLabel }) {
  return (
    <button
      type="button"
      className="mat-act mat-act--add"
      onClick={onClick}
      aria-label={ariaLabel || `+ ${label}`}
    >
      <RecIcon name="plus" />
      <span>{label}</span>
    </button>
  );
}
